import {StatusBar} from 'react-native';

/**
 * Reference-counted "light status-bar glyphs" for the dark POS screens.
 *
 * Several focused dark screens can overlap during a transition (the next screen
 * may gain focus before the previous one blurs), so each holder releases its
 * claim and only the LAST release restores the app's own style. Without the
 * count, a late blur of the Hub would flip the bar back to dark glyphs on top of
 * the already-focused dark Sale screen.
 */
let holders = 0;

const setBarStyle = (style) => {
    try {
        StatusBar?.setBarStyle?.(style, true);
    } catch (_error) {
        // Web / tests: no native status bar.
    }
};

/**
 * Switches the status bar to light glyphs until the returned release is called.
 *
 * @param {'light-content'|'dark-content'} restoreStyle Style to restore once no screen holds the bar.
 * @returns {function(): void} Idempotent release.
 */
export const holdLightStatusBar = (restoreStyle) => {
    holders += 1;
    setBarStyle('light-content');
    let released = false;

    return () => {
        if (released) {
            return;
        }
        released = true;
        holders = Math.max(0, holders - 1);
        if (holders === 0) {
            setBarStyle(restoreStyle);
        }
    };
};

/** Test helper: forgets every holder. */
export const resetPosStatusBarForTests = () => {
    holders = 0;
};

export default holdLightStatusBar;
